import { makeAutoObservable, runInAction } from 'mobx';
import { RootStore } from 'store/rootStore';
import { formUtils } from '@insurancemenu/imenu-components-lib';
import { FormObjectFromJSON, ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { CartBrowsingCriteria, Portfolio } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { INITIAL_FORM_OBJECT } from 'store/domain/formStore';
import { INITIAL_BROWSING_CRITERIA } from 'store/domain/cartStore';
import { BrowsingInfo } from '@insurancemenu/imenu-components-lib/src/types/productCardsTypings';

export class BrowsingPortfolioConfigModalStore {
  rootStore: RootStore;
  form: FormObjectFromJSON;
  dynamicForm: null | formUtils.DynamicFormController;

  loading = false;
  showConfigurePlanModal = false;
  productLineId: ProductLineId = 'GroupDental';
  portfolioBrowsingCriteria: CartBrowsingCriteria;

  setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  async openConfigurePlanModal(portfolio: Portfolio, effectiveDate: string, bcIndex: number | null): Promise<void> {
    this.showConfigurePlanModal = true;
    this.setLoading(true);
    this.productLineId = portfolio.productLineId;
    this.dynamicForm = null;
    try {
      const res = await this.rootStore.formStore.requestPortfolioConfigForm(portfolio.id, effectiveDate);
      runInAction(() => {
        this.form = res.data.getBrowsingConfigFormByPortfolioId[0];
        // Bc index from default bc card is needed to set correct product line BC
        const bc = portfolio.bcVersions[bcIndex || 0];

        if (bc && bc[this.productLineId]) {
          this.portfolioBrowsingCriteria = bc;
          this.createFormController(bc[this.productLineId]);
        }
      });
    } catch (error) {
      this.rootStore.comparisonStore.showToast(
        'An error has occurred while attempting to retrieve the form for portfolio configuration.',
        ToastColorTypes.WARNING,
      );
      this.closeConfigurePlanModal();
    } finally {
      this.setLoading(false);
    }
  }

  closeConfigurePlanModal(): void {
    this.showConfigurePlanModal = false;
  }

  createFormController(answers: BrowsingInfo | undefined): void {
    this.setLoading(true);
    const params = formUtils.createDynamicFormControllerParamsFromJSON(this.form);
    this.dynamicForm = new formUtils.DynamicFormController(
      params.fields,
      params.enableMastersObject,
      params.customDynamicFields,
    );
    if (answers) {
      this.dynamicForm.populateFields(answers);
    }
    this.setLoading(false);
  }

  // eslint-disable-next-line class-methods-use-this
  saveAnswers(): void {
    const browsingCriteriaAnswersFromForm = this.portfolioBrowsingCriteria[this.productLineId] || {};

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    Object.keys(this.dynamicForm!.fields).forEach((key) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      browsingCriteriaAnswersFromForm[key] = this.dynamicForm!.fields[key].value!.toString();
    });

    this.portfolioBrowsingCriteria[this.productLineId] = browsingCriteriaAnswersFromForm;
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.dynamicForm = null;
    this.form = INITIAL_FORM_OBJECT;
    this.portfolioBrowsingCriteria = INITIAL_BROWSING_CRITERIA;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
